module.exports = __webpack_public_path__ + "img/jianlian.a003593b.svg";